export default "__VITE_ASSET__$8PmR5be__"